<template style="touch-action: none;">
  <div></div>
</template>

<script>
  Array.prototype.remove = function() {
      var what, a = arguments, L = a.length, ax;
      while (L && this.length) {
          what = a[--L];
          while ((ax = this.indexOf(what)) !== -1) {
              this.splice(ax, 1);
          }
      }
      return this;
  };
  export default {
    name: 'App',
    props: ['baseURL','baseLINE','baseAPI','baseADMIN','tax'],
    components: {
    },
    data(){
      return{
        
      }
    },
    
    
    mounted() {
      location.href=this.baseADMIN+"/employee/employee_index.html"
    },
    methods:{
    }
  }
  </script>
  <style>
    .text-small{
      font-size: 8px;
    }
    .position-center{
      position: relative;
      margin: auto;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
    }
  </style>